import { useL10n } from "@ews/react-localization-context";
import { IonButton, IonItem, IonLabel } from "@ionic/react";
import { useModifyUserNotifications, useUser, useUserNotifications } from "../../../ReactData/user";
import { useIsMobile } from "../../../Responsive";
import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsTableRow from "../../../Settings/SettingsComponents/SettingsTable/SettingsRow/SettingsTableRow";
import SettingsTableColumn from "../../../Settings/SettingsComponents/SettingsTable/SettingsTableColumn/SettingsTableColumn";
import SettingsTableGrid from "../../../Settings/SettingsComponents/SettingsTable/SettingsTableGrid/SettingsTableGrid";
import PushOption from "../PushSettings/Components/Options/Options";
import { EmailSettingsProps } from "./types";

import
{
    NotificationChannel,
    permissionAllowed,
    setNotificationChannel,
    unsetNotificationChannel,
    UserNotifications
} from '@ews/react-data';
import { useMyPermissions, useMyProfileId } from "../../../Login/LoginProvider";
import { EntityNotificationSetting } from "./component/EntityNotificationSetting/EntityNotificationSetting";

const EmailSettings: React.FC<EmailSettingsProps> = ({ id }) =>
{
    function setValues(status: boolean)
    {
        const fn = status ? setNotificationChannel : unsetNotificationChannel;

        return {
            technicalMessageSilent: fn(userNotification.technicalMessageSilent || 0, NotificationChannel.EMAIL | NotificationChannel.EMAIL_END),
            fireAlarm: fn(userNotification.fireAlarm, NotificationChannel.EMAIL | NotificationChannel.EMAIL_END),
            fireAlert: fn(userNotification.fireAlert, NotificationChannel.EMAIL | NotificationChannel.EMAIL_END),
            preAlarm: fn(userNotification.preAlarm, NotificationChannel.EMAIL | NotificationChannel.EMAIL_END),
            testScenario: fn(userNotification.testScenario, NotificationChannel.EMAIL | NotificationChannel.EMAIL_END),
            testCondition: fn(userNotification.testCondition, NotificationChannel.EMAIL | NotificationChannel.EMAIL_END),
            testActivation: fn(userNotification.testActivation, NotificationChannel.EMAIL | NotificationChannel.EMAIL_END),
            testAlarm: fn(userNotification.testAlarm, NotificationChannel.EMAIL | NotificationChannel.EMAIL_END),
            activeOutput: fn(userNotification.activeOutput, NotificationChannel.EMAIL | NotificationChannel.EMAIL_END),
            fault: fn(userNotification.fault, NotificationChannel.EMAIL | NotificationChannel.EMAIL_END),
            technicalMessage: fn(userNotification.technicalMessage, NotificationChannel.EMAIL | NotificationChannel.EMAIL_END),
            disablement: fn(userNotification.disablement, NotificationChannel.EMAIL | NotificationChannel.EMAIL_END),
            extinguishingEvent: fn(userNotification.extinguishingEvent, NotificationChannel.EMAIL | NotificationChannel.EMAIL_END),
            status: fn(userNotification.status, NotificationChannel.EMAIL | NotificationChannel.EMAIL_END),
        };
    }

    const user = useUser(id);
    const userNotification = useUserNotifications(id);

    const modifyNotification = useModifyUserNotifications();

    const myPermissions = useMyPermissions();
    const myId = useMyProfileId();
    const allowedToEdit = myId === id ? true : permissionAllowed(myPermissions.createUser || 0);

    const updateNotification = async (data: UserNotifications) =>
    {
        await modifyNotification(user.id!, data);
    };

    const { translate: t } = useL10n();
    const mobileView = useIsMobile();
    const titlePosition = mobileView ? { textAlign: 'center' } : { textAlign: 'left', verticalAlign: 'sub' };
    // const childPosition = { marginLeft: '20px', fontStyle: 'italic', fontSize: 'medium !important' };

    const sizeMainCol = mobileView ? "12" : "6";
    const sizeSoundCol = "2";
    const otherCols = "1";

    // const EmailDataRef = useRef(userData);

    //const { fireAlarm, preAlarm, firePreWarning, testAlarm, online, fault, technicalMessage, extinguishingEvent, disablement, activeOutput, } = EmailDataRef.current;


    return <>
        <SettingsCol size={sizeMainCol} xl={sizeMainCol} md={sizeMainCol} lg={sizeMainCol}>
            <SettingsTableGrid>
                <SettingsTableRow hidden={mobileView}>
                    <SettingsTableColumn size="4" center={false}>
                        <p style={{ margin: 0 }}>{`${t('[SID_MNU_HK_EVENTS]')}:`}</p>
                    </SettingsTableColumn>
                    <SettingsTableColumn size={otherCols}>
                        <IonLabel style={{ textAlign: "center", margin: 0 }}>{`${t('[REACT_BEGIN]')}:`}</IonLabel>
                    </SettingsTableColumn>
                    <SettingsTableColumn size={otherCols}>
                        <IonLabel style={{ textAlign: "center", margin: 0 }}>{`${t('COM_FACPMANAGEMENT_END_EVENT')}:`}</IonLabel>
                    </SettingsTableColumn>
                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_MNU_TAB_ALARMS]"
                        size={otherCols}
                        options={{
                            email: "begin",
                            email_end: "end",
                        }}
                        value={userNotification.fireAlarm || 0}
                        onChange={(fireAlarm) => updateNotification({ fireAlarm } as UserNotifications)}

                    />
                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_DEV_STATE_PREALARM]"
                        size={otherCols}
                        options={{
                            email: "begin",
                            email_end: "end",
                        }}
                        value={userNotification.preAlarm || 0}
                        onChange={(preAlarm) => updateNotification({ preAlarm } as UserNotifications)}

                    />
                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_EV_FIRE_PREALARM_SH]"
                        size={otherCols}
                        options={{
                            email: "begin",
                            email_end: "end",
                        }}
                        value={userNotification.fireAlert || 0}
                        onChange={(fireAlert) => updateNotification({ fireAlert } as UserNotifications)}

                    />
                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_ONE_TEST_ALARM]"
                        size={otherCols}
                        options={{
                            email: "begin",
                            email_end: "",
                        }}
                        value={userNotification.testScenario || 0}
                        onChange={(testScenario) => updateNotification({ testScenario } as UserNotifications)}

                    />
                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_MNU_TAB_ACT_OUTP]"
                        size={otherCols}
                        options={{
                            email: "begin",
                            email_end: "",
                        }}
                        value={userNotification.activeOutput || 0}
                        onChange={(activeOutput) => updateNotification({ activeOutput } as UserNotifications)}

                    />
                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_MNU_TAB_FAULTS]"
                        size={otherCols}
                        options={{
                            email: "begin",
                            email_end: "end",
                        }}
                        value={userNotification.fault || 0}
                        onChange={(fault) => updateNotification({ fault } as UserNotifications)}

                    />
                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_EV_TECHN_MESS_ALARM]"
                        size={otherCols}
                        options={{
                            email: "begin",
                            email_end: "end",
                        }}
                        value={userNotification.technicalMessage || 0}
                        onChange={(technicalMessage) => updateNotification({ technicalMessage } as UserNotifications)}

                    />
                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_EV_TECHN_MESS_SW_OFF_ZONE_SH]"
                        size={otherCols}
                        options={{
                            email: "begin",
                            email_end: "end",
                        }}
                        value={userNotification.disablement || 0}
                        onChange={(disablement) => updateNotification({ disablement } as UserNotifications)}

                    />
                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_MNU_TAB_EXT_EV]"
                        size={otherCols}
                        options={{
                            email: "begin",
                            email_end: "end",
                        }}
                        value={userNotification.extinguishingEvent || 0}
                        onChange={(extinguishingEvent) => updateNotification({ extinguishingEvent } as UserNotifications)}

                    />
                </SettingsTableRow>

                <SettingsTableRow>
                    <PushOption
                        disabled={!allowedToEdit}
                        style={titlePosition}
                        center={false}
                        label="[SID_MNU_TAB_STATUS]"
                        size={otherCols}
                        options={{
                            email: "begin",
                            email_end: "end",
                        }}
                        value={userNotification.status || 0}
                        onChange={(status) => updateNotification({ status } as UserNotifications)}

                    />
                </SettingsTableRow>



            </SettingsTableGrid>
            <IonItem lines="none">
                <div style={{ width: "100%" }}>
                    <IonButton
                        disabled={!allowedToEdit}
                        color={"success"}
                        expand={"full"}
                        onClick={() =>
                        {
                            const allValues = {


                                ...setValues(true),

                                activeOutputSilent: true,
                            };
                            updateNotification(allValues as UserNotifications);



                        }}>{t("TD_GROSS_ALLE")}</IonButton>
                </div>
            </IonItem>
            <IonItem>
                <div style={{ width: "100%" }}>
                    <IonButton
                        disabled={!allowedToEdit}
                        color={"danger"}
                        expand={"full"}
                        onClick={() =>
                        {
                            const defaultValues = {
                                ...setValues(false),
                                fireAlarmSound: 'default',
                                fireAlertSound: 'default',
                                preAlarmSound: 'default',
                                testScenarioSound: 'default',
                                activeOutputSound: 'default',
                                activeOutputSilent: false,
                                faultSound: 'default',
                                technicalMessageSound: 'default',
                                disablementSound: 'default',
                                extinguishingEventSound: 'default',
                                statusSound: 'default',
                            };
                            updateNotification(defaultValues as UserNotifications);

                        }}>{t("TPL_BEEZ3_RESET")}</IonButton>
                </div>
            </IonItem>
        </SettingsCol>
        {/* <SettingsCol>
            <SettingsTitle text={"E-mail notifications at"} endText={':'} />
            <SettingsCheckbox text={"COM_BANNERS_NEW_CLIENT"} checked={EmailDataRef.current.newClient} onChange={(checked) => { EmailDataRef.current.newClient = checked; }} />
            <SettingsCheckbox text={"COM_FACPMANAGEMENT_ADMINEVENT_NEW_RESELLER"} checked={EmailDataRef.current.newReseller} onChange={(checked) => { EmailDataRef.current.newReseller = checked; }} />
            <SettingsCheckbox text={"COM_FACPMANAGEMENT_USERS_ADD_NEW"} checked={EmailDataRef.current.newUser} onChange={(checked) => { EmailDataRef.current.newUser = checked; }} />
            <SettingsCheckbox text={"COM_FACPMANAGEMENT_FACPS_ADD_NEW"} checked={EmailDataRef.current.newSystem} onChange={(checked) => { EmailDataRef.current.newSystem = checked; }} />
            <SettingsCheckbox text={"COM_FACPMANAGEMENT_SHARE_HEADLINE_INVITE"} checked={EmailDataRef.current.newEnablement} onChange={(checked) => { EmailDataRef.current.newEnablement = checked; }} />
            <SettingsCheckbox text={"COM_FACPMANAGEMENT_ADMINEVENT_NEW_GPS_IMAGE"} checked={EmailDataRef.current.newGpsArea} onChange={(checked) => { EmailDataRef.current.newGpsArea = checked; }} />

        </SettingsCol> */}
        <SettingsCol>
            <EntityNotificationSetting
                userNotification={userNotification as any}
                onUpdate={(data) => { updateNotification(data as UserNotifications); }} />

        </SettingsCol>

    </>;
};

export default EmailSettings;
